import { render, staticRenderFns } from "./AffiliateMainPage.vue?vue&type=template&id=096f4979&scoped=true&lang=pug&"
import script from "./AffiliateMainPage.vue?vue&type=script&lang=js&"
export * from "./AffiliateMainPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateMainPage.vue?vue&type=style&index=0&id=096f4979&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f4979",
  null
  
)

export default component.exports